type Props = {
  columns?: number;
  rows?: number;
};

const SkeltonTableRow = ({ columns = 6, rows = 8 }: Props) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex} className="animate-pulse border-b border-edge">
          {Array.from({ length: columns }).map((__, colIndex) => (
            <td key={colIndex} className="px-4 py-4">
              <div className="h-4 w-[85%] rounded bg-skeleton" />
              {colIndex === 0 ? (
                <div className="mt-2 h-3 w-[55%] rounded bg-skeleton" />
              ) : null}
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export default SkeltonTableRow;
